<template>
  <transition
    :enter-active-class="onEnterClasses"
    :enter-leave-class="onLeaveClasses"
    :appear="showTransitionOnAppear"
    name="collapsible"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave"
  >
    <slot></slot>
  </transition>
</template>

<script>
export default {
  props: {
    showTransitionOnAppear: {type: Boolean, default: true},
    onEnterClasses: {type: String, default: 'collapsible-enter-active'},
    onLeaveClasses: {type: String, default: 'collapsible-leave-active'}
  },
  methods: {
    afterEnter(element) {
      element.style.height = 'auto';
    },
    enter(element) {
      element.style.width = getComputedStyle(element).width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const height = getComputedStyle(element).height;
      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      getComputedStyle(element).height;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    leave(element) {
      element.style.height = getComputedStyle(element).height;
      getComputedStyle(element).height;

      setTimeout(() => {
        element.style.height = 0;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.collapsible-enter-active {
  transition: height 0.2s ease-in-out, opacity 0.2s ease-in-out 0.2s;
  overflow: hidden;
}

.collapsible-leave-active {
  transition: height 0.2s ease-in-out 0.2s, opacity 0.2s ease-in-out;
  overflow: hidden;
}

.collapsible-enter,
.collapsible-leave-to {
  height: 0;
  opacity: 0;
}
</style>
